import { render, staticRenderFns } from "./DynamicTabs.vue?vue&type=template&id=1f8e4c14"
import script from "./DynamicTabs.vue?vue&type=script&lang=js"
export * from "./DynamicTabs.vue?vue&type=script&lang=js"
import style0 from "./DynamicTabs.vue?vue&type=style&index=0&id=1f8e4c14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports